/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientActionLogDto } from '../../models/client-action-log-dto';

export interface ClientActionLogControllerFindAll$Params {
}

export function clientActionLogControllerFindAll(http: HttpClient, rootUrl: string, params?: ClientActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientActionLogDto>>> {
  const rb = new RequestBuilder(rootUrl, clientActionLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientActionLogDto>>;
    })
  );
}

clientActionLogControllerFindAll.PATH = '/api/clientActionLog';
